import CustomButton from './CustomButton';
import { SegnalazioniService } from '../../../services/controllers/segnalazioni-services/SegnalazioniService';
import SegnalazioneFlowState from '../../variables/SegnalazioneFlowState';
import CustomButtonSecondary from './CustomButtonSecondary';
import { useEffect,useState } from 'react';
import SegnalazioneTypeLabels from '../../variables/SegnalazioneTypeLabels';
import { SendingStorOutput } from '../../../services/models/output-objs/sendingStoreOutput';
import StorBeFeParser from '../../utils/storBeFeParser';
import SegnalazioneType from '../../variables/SegnalazioniType';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Button } from 'react-bootstrap';
import { AttachmentService } from '../../../services/controllers/attachment-services/AttachmentService';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { FileUploader } from 'react-drag-drop-files';
import SegnalazioniCollegateGrid from '../../../pages/stor-details/SegnalazioniCollegateGrid';

type SegnalazioneDetailButtonsInterface = {
    hanldeOpenModalAssegnaSegnalazione : any,
    handleOpenModalRifiutaSegnalazione : any,
    segnalazione : any,
    user:any,
    notificationFunctions : any
}

const SegnalazioneDetailButtons = ({
                                       handleOpenModalRifiutaSegnalazione,
                                       hanldeOpenModalAssegnaSegnalazione,
                                       segnalazione,
                                       user,
                                       notificationFunctions} : SegnalazioneDetailButtonsInterface) => {

    const segnalazioniService : SegnalazioniService = new SegnalazioniService();
    const [open, setOpen] = useState(false);
    const [openChain, setOpenChain] = useState(false);                                   
    const [attachments, setAttachments] = useState<any[]>([]);
    const [attachmentUploaded, setAttachmentsUploaded] = useState<attachmentArray[]>([])
    const attachmentService: AttachmentService = new AttachmentService();
    const [printed, setPrinted] = useState <boolean>(false);
    const [startUpload, setStartUpload] = useState <boolean>(false);
    const [hitoryStor, setHitoryStor] = useState<any[]>([]);

    let sum = 0

    type attachmentArray = {
        id : number,
        name : string
    }

    useEffect(() => {}, [attachments]);
    useEffect(() => {}, [attachmentUploaded]);


    async function downloadSegnalazione() {
        if(segnalazione && segnalazione.systemInformations && segnalazione.systemInformations.id){
            let id = segnalazione.systemInformations.id
            const attachmentService = new AttachmentService();
            attachmentService.openFileInNewWindowStampone(id);
            setPrinted(true)
        }
          
    }

    const handleCancel = () => {
        setOpen(false)
        setOpenChain(false)
    }

    async function FileSelectHandler(e : any) {
        setStartUpload(true)
        const segnalazioniService : SegnalazioniService = new SegnalazioniService();
        const file = e
        sum = sum + file.size
        if (segnalazioniService.getAllegati().includes(file.type) && sum < 50000000) {
            addFileToAttachments(file)
        }
        else{
            if (sum > 50000000){
                setStartUpload(false)
                notificationFunctions.setWarningMessage("La somma degli allegati non dev'essere superiore a 50 MB")
            }
            if(!segnalazioniService.getAllegati().includes(file.type)){
                setStartUpload(false)
                notificationFunctions.setWarningMessage("Il formato del file non è supportato")
            }   
        }         
    }

    async function addFileToAttachments(file : any) {
        let fileType = file.type
        if(fileType === '' && file.name.endsWith('.msg')){
            fileType = 'application/vnd.ms-outlook'
        }
        else if (!fileType || fileType !== 'application/pdf'){
            setStartUpload(false)
            notificationFunctions.setWarningMessage('Il formato del file deve essere pdf')
        }
        else {
            setAttachments(attachments => attachments.concat(file))
            const fd = new FormData();
            const ft : any = true;
            fd.append('file', file);
            let id = ""
            if(segnalazione && segnalazione.systemInformations && segnalazione.systemInformations.id)
                id = segnalazione.systemInformations.id
            fd.append('storId', id);
            fd.append('mainDocument', ft);
            const response = await attachmentService.uploadFileToStor(fd);
            if (response && response.id){
                attachmentUploaded.push({id: response.id, name: file.name});
                setAttachmentsUploaded(attachmentUploaded)
                if(segnalazione.systemInformations.state === SegnalazioneFlowState.FASE_DI_RETTIFICA )
                    sendRettifica();
                else
                    sendSegnalazione();
            }
            else{
                const tmpAttachments : any[] = []
                attachments.map(attachment => {
                    if (attachment.name !== file.name) tmpAttachments.push(attachment)
                })
                setAttachments(tmpAttachments)
                notificationFunctions.setErrorMessage('Errore nel caricamento del file');
                setStartUpload(false)
            }
        }
    }

    async function sendRettifica() {
        setOpen(false)
        let newSegnalazione = JSON.parse(sessionStorage.getItem("newSegnalazione") || '')
        const segnalazioneT = newSegnalazione['systemInformations'] ? SegnalazioneTypeLabels[newSegnalazione['systemInformations']['type']] : ""
        const sendingStor : SendingStorOutput = StorBeFeParser.parseFetoBe(newSegnalazione,segnalazioneT,'0',sessionStorage?.getItem('idSegnalazioneCreazione') || null)
        await sendRettificaSubmit(sendingStor,sessionStorage?.getItem('idSegnalazione')||"", sessionStorage?.getItem('idSegnalazioneCreazione')||"")
    }

    async function sendSegnalazione() {
        setOpen(false)
        await getSegnalazioneSubmit(sessionStorage?.getItem('idSegnalazioneCreazione')||"")
    }

    
    async function getSegnalazioneSubmit(idSegnalazione : string){
        let response = await segnalazioniService.sendSegnalazione(idSegnalazione);
        if (response && response.id) {
            setOpen(false)
            setStartUpload(false)
            const parsedSegnalazione = await StorBeFeParser.parseBetoFe(response)
            sessionStorage.setItem('idSegnalazioneCreazione', parsedSegnalazione?.systemInformations?.id || '')
            sessionStorage.setItem('segnalazioneGetStorById', JSON.stringify(parsedSegnalazione))
            sessionStorage.setItem('extraInfo', JSON.stringify(response.extraInfo) || '')
            sessionStorage.removeItem('arrivedFromSegnalazioneCreate')
            sessionStorage.removeItem('newSegnalazione')
            window.location.href = "/stor-fe";
            sessionStorage.setItem('successCreatingSegnalazione', 'true')
        }
        else{
            setStartUpload(false)
            notificationFunctions.setErrorMessage('Errore nella creazione della segnalazione, riprovare più tardi')
        }
    }

    async function sendRettificaSubmit(sendingStor: SendingStorOutput,idSegnalazione : string, idSegnalazioneNew : string){
        let response = await segnalazioniService.sendRettifica(sendingStor,idSegnalazione,idSegnalazioneNew);
        if (response && response.id) {
            setStartUpload(false)
            const parsedSegnalazione = await StorBeFeParser.parseBetoFe(response)
            sessionStorage.setItem('idSegnalazioneCreazione', parsedSegnalazione?.systemInformations?.id || '')
            sessionStorage.setItem('segnalazioneGetStorById', JSON.stringify(parsedSegnalazione))
            sessionStorage.setItem('extraInfo', JSON.stringify(response.extraInfo) || '')
            sessionStorage.removeItem('arrivedFromSegnalazioneCreate')
            sessionStorage.removeItem('newSegnalazione')
            sessionStorage.removeItem('SegnalazioneInviataAzione')
            window.location.href = "/stor-fe";
            sessionStorage.setItem('successCreatingSegnalazione', 'true')
        }
        else{
            setStartUpload(false)
            notificationFunctions.setErrorMessage('Errore nella creazione della segnalazione')
        }
    }

    function getInstrument(segnalazione : any) : string{
        let instrumentString = ''
        if(segnalazione.financialInstruments && segnalazione.financialInstruments.length>2)
            instrumentString = 'Più strumenti finanziari'
        else if(segnalazione.financialInstruments.length>0){
            segnalazione.financialInstruments.forEach((instr:string) => {
                if(instrumentString === '')
                    instrumentString = instr
                else 
                    instrumentString = instrumentString + ',' + instr
            });
        }
        return instrumentString
    }

    async function getAllStorConnected(){
        let idSegnalazione = sessionStorage.getItem('idSegnalazioneCreazione')
        let response = await segnalazioniService.getHistory(idSegnalazione);
        if (response && response.storHistory.length>0) {
            response.storHistory?.forEach((element: any) =>{
                element.financialString = getInstrument(element)
            })

            setHitoryStor(response.storHistory)
        }
        else
            setHitoryStor([])
        setOpenChain(true);
    }

    function modifySegnalazione() {
        setPrinted(false);
        if(segnalazione['ordineOperazione']['descrizioneOrdine'] && segnalazione['ordineOperazione']['descrizioneOrdine'].length > 0){
            if(segnalazione['ordineOperazione']['descrizioneOrdine'][0]['descrOperSospette']){
                segnalazione['ordineOperazione']['descrizioneOrdine'] = {
                    multiInsertOption : true,
                    descrizioneOrdine : segnalazione['ordineOperazione']['descrizioneOrdine'][0]['descrOperSospette']
                }
            }
        }
        if(segnalazione['systemInformations'] && segnalazione['systemInformations']['type']){
            switch(segnalazione['systemInformations']['type']){
                case 'STOR':
                    sessionStorage.setItem('segnalazioneType', SegnalazioneType.STOR)
                    break;
                case 'Market Observation':
                    sessionStorage.setItem('segnalazioneType', SegnalazioneType.MARKET_OBSERVATION)
                    break;
                default :
                    sessionStorage.setItem('segnalazioneType', SegnalazioneType.ALTRO)
            }
        }
        sessionStorage.setItem('newSegnalazione', JSON.stringify(segnalazione))
        window.location.href = '/stor-fe/stor/create'
    }


    return (
        <div className="row mt-4">
            {segnalazione.systemInformations.state === SegnalazioneFlowState.IN_COMPILAZIONE ?
                <>
                    <CustomButtonSecondary
                        onClick={() => {downloadSegnalazione()}}
                        className="margin-right-5 col-auto"
                        disabled = {startUpload}
                        variant="contained">Stampa segnalazione</CustomButtonSecondary>
                    <CustomButton
                        onClick = {() => {setOpen(true)}}
                        className="margin-right-5 col-auto"
                        variant="contained"
                        disabled = {!printed || startUpload}>Carica documento e Invia segnalazione</CustomButton>
                    <CustomButtonSecondary
                        onClick={() => {modifySegnalazione()}}
                        className="margin-right-5 col-auto"
                        disabled = {startUpload}
                        variant="contained">Modifica segnalazione</CustomButtonSecondary>
                    <CustomButtonSecondary
                        onClick={() => {
                            sessionStorage.removeItem('idSegnalazione') 
                            sessionStorage.removeItem('idSegnalazioneCreazione')
                            sessionStorage.removeItem('segnalazioneType') 
                            sessionStorage.removeItem('newSegnalazione')  
                            sessionStorage.removeItem('segnalazioneGetStorById')
                            sessionStorage.removeItem('extraInfo')
                            window.location.href = "/stor-fe";}}
                        className="margin-right-5 col-auto"
                        disabled = {startUpload}
                        variant="contained">Torna alla homepage</CustomButtonSecondary>
                    <Dialog
                        open={open}
                        // onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth
                        >
                        <DialogTitle id="alert-dialog-title">
                        Carica documento e Invia segnalazione
                        </DialogTitle>
                        <DialogContent>
                        <DialogContentText id="alert-dialog-description" className='text-danger'>
                            Allegando il documento si procederà con l'invio della segnalazione. Assicurarsi che il documento sia firmato.
                        </DialogContentText>
                        <FileUploader
                            classes="file-uploader mt-3 text-center w-100" 
                            multiple={false}
                            handleChange={FileSelectHandler}
                            children=
                            {<div>     
                                <div className="mt-5"><FileUploadOutlinedIcon sx={{ fontSize: 80 }} ></FileUploadOutlinedIcon></div>               
                                <div className="mt-3 font-medium-custom color-secondary text-bold" >Trascina qui gli allegati che desideri caricare</div>
                                <div className="mt-3 font-medium-custom color-third">Oppure</div>
                                <CustomButtonSecondary className="mt-3 mb-5">Carica</CustomButtonSecondary>
                            </div>}
                        />
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleCancel}>Indietro</Button>
                        </DialogActions>
                    </Dialog>
                </>
                :
                <></>
            }
            {segnalazione.systemInformations.state === SegnalazioneFlowState.PROTOCOLLATA 
            || segnalazione.systemInformations.state === SegnalazioneFlowState.RETTIFICATA 
            || segnalazione.systemInformations.state === SegnalazioneFlowState.CANCELLATA 
            || segnalazione.systemInformations.state === SegnalazioneFlowState.DA_COMPLETARE
            || segnalazione.systemInformations.state === SegnalazioneFlowState.CHIUSURA_LO
            || segnalazione.systemInformations.state === SegnalazioneFlowState.CHIUSURA_L1 
            || segnalazione.systemInformations.state === SegnalazioneFlowState.ASSEGNATAFUNZ
            || segnalazione.systemInformations.state === SegnalazioneFlowState.PRESAINCARICO
            || segnalazione.systemInformations.state === SegnalazioneFlowState.INLAVORAZIONE
            || segnalazione.systemInformations.state === SegnalazioneFlowState.INLAVORAZIONECONCLUSAFASEUNO
            || segnalazione.systemInformations.state === SegnalazioneFlowState.TEMPSOSPESA
            || segnalazione.systemInformations.state === SegnalazioneFlowState.ANALISICONCLUSE
            || segnalazione.systemInformations.state === SegnalazioneFlowState.NONPORTAREINCOMITATO
            || segnalazione.systemInformations.state === SegnalazioneFlowState.CASODISCUSSO
            || segnalazione.systemInformations.state === SegnalazioneFlowState.CASOABM
            || segnalazione.systemInformations.state === SegnalazioneFlowState.INVIOURI
            || segnalazione.systemInformations.state === SegnalazioneFlowState.CONSEGNATABOZZANOTE
            || segnalazione.systemInformations.state === SegnalazioneFlowState.BOZZAREVISIONATA
            || segnalazione.systemInformations.state === SegnalazioneFlowState.ALTROESITO
            || segnalazione.systemInformations.state === SegnalazioneFlowState.DISCUSSACOMITATOAVVIO
            || segnalazione.systemInformations.state === SegnalazioneFlowState.DISCUSSACOMITATONOAVVIO
            || segnalazione.systemInformations.state === SegnalazioneFlowState.NOTARITIRATA
            || segnalazione.systemInformations.state === SegnalazioneFlowState.DISCUSSACOMITATOSOSPESA ?
                <>
                    <CustomButtonSecondary
                        onClick={() => {
                            sessionStorage.removeItem('idSegnalazione') 
                            sessionStorage.removeItem('idSegnalazioneCreazione')
                            sessionStorage.removeItem('segnalazioneType') 
                            sessionStorage.removeItem('newSegnalazione')  
                            sessionStorage.removeItem('segnalazioneGetStorById')
                            sessionStorage.removeItem('extraInfo')
                            window.location.href = "/stor-fe";}}
                        className="margin-right-5 col-auto"
                        variant="contained">Torna alla homepage</CustomButtonSecondary>
                    <CustomButtonSecondary
                        onClick = {() => {getAllStorConnected()}}
                        className="margin-right-5 col-auto"
                        variant="contained">Segnalazioni Collegate</CustomButtonSecondary>
                    <Dialog
                        open={openChain}
                        // onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth
                        maxWidth = "lg"
                        >
                        <DialogTitle id="alert-dialog-title">
                        Elenco Segnalazioni Collegate
                        </DialogTitle>
                        <DialogContent>
                            <SegnalazioniCollegateGrid
                                elements={hitoryStor}
                                user = {user} 
                            />
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleCancel}>Indietro</Button>
                        </DialogActions>
                    </Dialog>
                </>
                :
                <></>
            }
            {segnalazione.systemInformations.state === SegnalazioneFlowState.FASE_DI_RETTIFICA ?
                <>
                    <CustomButtonSecondary
                        onClick={() => {downloadSegnalazione()}}
                        className="margin-right-5 col-auto"
                        variant="contained">Stampa segnalazione</CustomButtonSecondary>
                    <CustomButton
                        onClick = {() => {setOpen(true)}}
                        //onClick={() => {sendSegnalazione()}}
                        className="margin-right-5 col-auto"
                        variant="contained"
                        disabled = {!printed}>Carica documento e Invia Integrazione</CustomButton>
                    <CustomButtonSecondary
                        onClick={() => {
                            sessionStorage.removeItem('idSegnalazione') 
                            sessionStorage.removeItem('idSegnalazioneCreazione')
                            sessionStorage.removeItem('segnalazioneType') 
                            sessionStorage.removeItem('newSegnalazione')  
                            sessionStorage.removeItem('SegnalazioneInviataAzione')
                            sessionStorage.removeItem('segnalazioneGetStorById')
                            sessionStorage.removeItem('extraInfo')
                            window.location.href = "/stor-fe";}}
                        className="margin-right-5 col-auto"
                        variant="contained">Torna alla homepage</CustomButtonSecondary>
                    <Dialog
                        open={open}
                        // onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth
                        >
                        <DialogTitle id="alert-dialog-title">
                        Carica documento e Invia Integrazione
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" className='text-danger'>
                                Allegando il documento si procederà con l'integrazione della segnalazione. Assicurarsi che il documento sia firmato.
                            </DialogContentText>
                            <FileUploader
                                classes="file-uploader mt-3 text-center w-100" 
                                multiple={false}
                                handleChange={FileSelectHandler}
                                children=
                                {<div>     
                                    <div className="mt-5"><FileUploadOutlinedIcon sx={{ fontSize: 80 }} ></FileUploadOutlinedIcon></div>               
                                    <div className="mt-3 font-medium-custom color-secondary text-bold" >Trascina qui gli allegati che desideri caricare</div>
                                    <div className="mt-3 font-medium-custom color-third">Oppure</div>
                                    <CustomButtonSecondary className="mt-3 mb-5">Carica</CustomButtonSecondary>
                                </div>}
                        />
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleCancel}>Indietro</Button>
                        </DialogActions>
                    </Dialog>
                </>
                :
                <></>
            }
        </div>

    );
}

export default SegnalazioneDetailButtons;
